<script>
import firebase from "firebase/firebase";

export default {
  methods: {
    isUserAdmin() {
      firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          this.$store.commit("SET_AUTH", user);
        } else {
          this.$store.commit("SET_AUTH", null);
        }
      });
    },
  },
  computed: {
    getAuth() {
      if (this.$store.getters.getAuth == null) {
        return false;
      } else {
        return true;
      }
    },
    getAuthWithRouter() {
      if (this.getAuth == false) {
        this.$router.replace("home");
      }
      return this.getAuth;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/mixins/user_detection.vue